import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { JsmContextualSuggestionsConfigProviderEntryEntrypointProps } from './JsmContextualSuggestionsConfigProviderEntry.entrypoint.types.tsx';

type JsmContextualSuggestionsConfigProviderEntrypointComponent = EntryPointComponent<
	{},
	{},
	JsmContextualSuggestionsConfigProviderEntryEntrypointProps,
	{} | null
>;

export const jsmContextualSuggestionsConfigProviderEntrypoint: EntryPoint<
	JsmContextualSuggestionsConfigProviderEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<JsmContextualSuggestionsConfigProviderEntrypointComponent>(
		/* webpackChunkName: "ai-rovo-actions-jsm-contextual-suggestions-provider" */ './JsmContextualSuggestionsConfigProviderEntry.tsx',
	),
	getPreloadProps: () => ({}),
});
